// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TaskAudit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  taskId!: number;
  updatedDate!: Date;
  fieldName!: string;
  action?: string;
  adminId!: number;
  newValue?: string;
  oldValue?: string;
  updatedBy?: string;
  task!: iTask;
}

